import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';

const SystemAttributes = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Jane Smith'  },
    { id: 3, name: 'Michael Johnson'  },
  ]);

  const handleEdit = (id) => {

  };

  const handleDelete = (id) => {
    
    setRows(rows.filter(row => row.id !== id));
    setSelectedRowId(null);  
  };

  const handleRowClick = (id) => { 
    setSelectedRowId(id === selectedRowId ? null : id);
  };

  const columns = [
    { field: 'name', headerName: 'Name', width: 200},
   ];

  const [searchTerm, setSearchTerm] = useState('');
  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const exportToExcel = () => {
    const fileName = 'locations.xlsx';
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const formattedRows = filteredRows.map(row => ({
      Name: row.name,
      'Sort Rank': row.sortrank,
    }));
    const ws = XLSX.utils.json_to_sheet(formattedRows);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(data);
    downloadLink.download = fileName;
    downloadLink.click();
  };

  return (
    <>
      <h2 className="title">System Attributes</h2> 
      <div style={{backgroundColor:"#f4f4f4",padding:"10px",width:"1560px",margin:"0 auto"}}>
      <div className="search" >
        <div className="row align-items-center">
         
            <div className="col-md-6 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
       
          <div className="col-md-6 d-flex justify-content-end">
            <button
              className="btn btn-primary"
              style={{backgroundColor:"#004aad",borderColor:'#004aad'}}
              onClick={exportToExcel}
            >
              Export to Excel
            </button>
          </div>
        </div>
      </div>

      <div style={{ height: 350, width: '100%', position: 'relative', marginTop: '2%', }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          rowSelected={selectedRowId !== null}
          onRowClick={(row) => handleRowClick(row.id)}
          components={{
            Toolbar: () => null,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            }, 
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',  
            },
            '& .MuiDataGrid-cell:focus-within': {
              outline: 'none',  
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: 'absolute',
              top: rows.findIndex(row => row.id === selectedRowId) * 52 + 48,
              right: '10px',
              display: 'flex',
              marginTop:'15px'
            }}
          >
            <button
              style={{
                padding: '8px 16px',
                backgroundColor: '#0d6efd', // Updated button color
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
              onClick={() => handleEdit(selectedRowId)}
            >
              Edit
            </button>
            <button
              style={{
                padding: '8px 16px',
                backgroundColor: '#0d6efd', // Updated button color
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              onClick={() => handleDelete(selectedRowId)}
            >
              Delete
            </button>
          </div>
        )}
      </div>
      </div>
    </>
  );
};

export default SystemAttributes;
